import { useTranslation } from "react-i18next";
import type { DailyRewardsStatus } from "../../models/apiTypes";
import { cn } from "../cn";


interface DailyRewardStreakBarProps {
  status: DailyRewardsStatus;
}

export default function DailyRewardStreakBar({ status }: DailyRewardStreakBarProps) {
  const { t } = useTranslation();
  const hasActiveDay = status.days.some(d => d.is_claimed || d.can_claim);

  return (
    <div className="relative flex w-full items-center justify-between">
      <div
        className={cn(
          'absolute top-[14px] left-0 h-px w-full',
          hasActiveDay ? 'bg-brand' : 'bg-text-light',
        )}
      />
      <div className="flex w-full items-start justify-between">
        {[1, 2, 3, 4, 5, 6, 7].map((day) => {
          const dayData = status.days.find((d) => d.day === day);
          const isClaimed = dayData?.is_claimed ?? false;
          const canClaim = dayData?.can_claim ?? false;
          const isGreen = isClaimed || canClaim;
          
          return (
            <div
              key={day}
              className="relative flex shrink-0 flex-col items-center gap-xs"
            >
              <div
                className={cn(
                  'flex h-7 w-7 items-center justify-center rounded-full border-2',
                  isGreen
                    ? 'border-brand bg-brand'
                    : 'border-text-light bg-text-light',
                )}
              >
                <img
                  src="/ui/daily-rewards/daily-rewards-mark.svg"
                  alt="✓"
                  className="h-3 w-[14px]"
                />
              </div>
              <span className="whitespace-nowrap [font-family:Lato,sans-serif] text-[10px] leading-[12px] font-normal text-white">
                {t("Day {{day}}", { day })}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
